import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSearchingResultsAppendSucceed, EGetSearchingResultsActionType } from './types';
import { ISearchingResults } from '../../../types/searchingResults';

export const getSearchingResultsAppendSucceed: (data: ISearchingResults) => TGetSearchingResultsAppendSucceed =
  actionGenerator<EGetSearchingResultsActionType.AppendSucceed, ISearchingResults>(
    EGetSearchingResultsActionType.AppendSucceed,
  );
